import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { hasTriggerFormSubmit } from "@circle-react/helpers/hasTriggerFormSubmit";

export interface UseSubmitViaKeyboardProps {
  enabled?: boolean;
}

export const useSubmitViaKeyboard = ({
  enabled = true,
}: UseSubmitViaKeyboardProps = {}) => {
  const context = useFormContext();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const listener = (event: KeyboardEvent) => {
      if (
        event.key === "Enter" &&
        (event.metaKey || event.ctrlKey) &&
        hasTriggerFormSubmit(context)
      ) {
        context.triggerFormSubmit();
      }
    };

    document.addEventListener("keydown", listener);

    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [enabled, context]);
};
